function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Module dependencies.
 */
var Socket = require('./sock');

var slice = require('../utils').slice;
/**
 * Expose `PubSocket`.
 */


module.exports = PubSocket;
/**
 * Initialize a new `PubSocket`.
 *
 * @api private
 */

function PubSocket() {
  Socket.call(this);
}
/**
 * Inherits from `Socket.prototype`.
 */


PubSocket.prototype.__proto__ = Socket.prototype;
/**
 * Send `msg` to all established peers.
 *
 * @param {Mixed} msg
 * @api public
 */

PubSocket.prototype.send = function (msg) {
  var socks = this.socks;
  var len = socks.length;
  var buf = this.pack(arguments);

  var _iterator = _createForOfIteratorHelper(socks),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var sock = _step.value;
      if (sock.writable) sock.write(buf);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return this;
};

PubSocket.prototype.sendv2 = function (data, cb) {
  var socks = this.socks;
  var len = socks.length;
  var sock;
  if (len == 0) return process.nextTick(cb);
  var buf = this.pack([data]);
  var i = 0;
  socks.forEach(function (sock) {
    if (sock.writable) sock.write(buf, function () {
      i++;
      if (i == len) process.nextTick(cb);
    });else {
      i++;
      if (i == len) process.nextTick(cb);
    }
  });
  return this;
};